var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentUploadOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#E4F2F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17918_52900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9991V14.9991H9V23.9991H23V14.9991H20V12.9991H23C24.1046 12.9991 25 13.8946 25 14.9991V23.9991C25 25.1037 24.1046 25.9991 23 25.9991H9C7.89543 25.9991 7 25.1037 7 23.9991V14.9991C7 13.8946 7.89543 12.9991 9 12.9991H12ZM16.8839 6.46768L20.2426 9.82644C20.6332 10.217 20.6332 10.8501 20.2426 11.2406C19.8521 11.6312 19.219 11.6312 18.8284 11.2406L17 9.41223V18.9991C17 19.5514 16.5523 19.9991 16 19.9991C15.4477 19.9991 15 19.5514 15 18.9991V9.41223L13.1716 11.2406C12.781 11.6312 12.1479 11.6312 11.7574 11.2406C11.3668 10.8501 11.3668 10.217 11.7574 9.82644L15.1161 6.46768C15.6043 5.97952 16.3957 5.97952 16.8839 6.46768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17918_52900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadOff);
export default __webpack_public_path__ + "static/media/documentUploadOff.5c5b06965ffb359226e54c42e61e0d44.svg";
export { ForwardRef as ReactComponent };